<template>
  <ThemeProvider class="landing-scene">
    <TopHeader></TopHeader>
    <ContentSection>
      <SceneInfo class="landing-scene__section" :data="sceneDetails" />
    </ContentSection>
    <SceneDivider></SceneDivider>
    <ContentSection>
      <SceneDemo ref="sceneDemoRef" class="landing-scene__section" :data="sceneDetails" />
    </ContentSection>
    <SceneDivider v-if="sceneDetails?.project_templates.length"></SceneDivider>
    <ContentSection>
      <SceneSimilar
        class="landing-scene__section"
        :data="sceneDetails"
        :refresh="refreshSceneDetails"
        @create="onFreeUse"
      />
    </ContentSection>
    <AppFooterBanner :handler="onFreeUse"></AppFooterBanner>
    <AppFooter></AppFooter>
  </ThemeProvider>
</template>

<script setup lang="ts">
import { getSceneDetails, getStudioDetails } from '~/api';
import AppFooterBanner from '~/design/widgets/start-right-now/index.vue';
import ThemeProvider from '~/design/widgets/theme-provider/index.vue';
import TopHeader from '~/design/widgets/top-header/index.vue';
import ContentSection from '../main-cn/components/page.vue';
import SceneDivider from './components/divider.vue';
import SceneDemo from './sections/scene-demo.vue';
import SceneInfo from './sections/scene-info.vue';
import SceneSimilar from './sections/scene-similar.vue';

const AppFooter = defineAsyncComponent(() =>
  isChinese()
    ? import('~/design/widgets/bottom-footer/footer-cn.vue').then(m => m.default)
    : import('~/design/widgets/bottom-footer/footer-en.vue').then(m => m.default),
);

const route = useRoute();

const { refresh: refreshSceneDetails, data: sceneDetails } = useAsyncData(
  async () => {
    if (route.query.look_name) {
      const res = await getSceneDetails();
      return res.data;
    } else if (route.params.studioScene) {
      const studioScene = route.params.studioScene as string;
      const lastIndex = studioScene.lastIndexOf('-');
      const identity = lastIndex !== -1 ? studioScene.substring(lastIndex + 1) : studioScene;
      const res = await getStudioDetails(identity);
      return res.data;
    }
  },
  {
    watch: [() => route.query.look_name, () => route.params.studioScene],
  },
);

const sceneDemoRef = ref<InstanceType<typeof SceneDemo>>();

const onFreeUse = () => {
  if (sceneDemoRef.value) {
    sceneDemoRef.value.freeUseScene();
  }
};
</script>

<style lang="scss">
.landing-scene {
  // 覆盖内部 xTop 背景色
  .header {
    background-color: var(--white-1);
  }
  &__section {
    width: 1200px;
    margin: 0 auto;
  }
}

@media screen and (min-width: 1600px) and (max-width: 1919.98px) {
  .landing-scene__section {
    width: calc(1200px + (1440 - 1200) * (100vw - 1600px) / (1920 - 1600));
  }
}

@media screen and (min-width: 1920px) {
  .landing-scene__section {
    width: 1440px;
  }
}
</style>
